const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.dev.tiqs.in',
};

export default config;
